<template>
  <div class="Home">
			<VAccount></VAccount>
			<div style="height: 116px;"></div>
<!--			<VNav></VNav>-->
			<VBanner></VBanner>
				<!--<ul class="content_box_top">
				      <li>
				        <a href=""><img src="../../static/青岛纯晶稀有元素有限公司图片+文字材料/成套的实物元素周期表/IMG_20170407_194703.jpg" width="150px"></a>
				        <h3 class="obj_title">化学元素周期表</h3>
				        <p>主营各种实物化学元素周期表<br>化学元素周期表</p>
				      </li>
				      <li>
				        <a href=""><img src="../../static/青岛纯晶稀有元素有限公司图片+文字材料/成套的实物元素周期表/IMG_20170407_194703.jpg" width="150px"></a>
				        <h3 class="obj_title">化学元素周期表</h3>
				        <p>主营各种实物化学元素周期表<br>化学元素周期表</p>
				      </li>
				      <li>
				        <a href=""><img src="../../static/青岛纯晶稀有元素有限公司图片+文字材料/成套的实物元素周期表/IMG_20170407_194703.jpg" width="150px"></a>
				        <h3 class="obj_title">化学元素周期表</h3>
				        <p>主营各种实物化学元素周期表<br>化学元素周期表</p>
				      </li>
				      <li>
				        <a href=""><img src="../../static/青岛纯晶稀有元素有限公司图片+文字材料/成套的实物元素周期表/IMG_20170407_194703.jpg" width="150px"></a>
				        <h3 class="obj_title">化学元素周期表</h3>
				        <p>主营各种实物化学元素周期表<br>化学元素周期表</p>
				      </li> 
				</ul>			-->
			<div class="ab_out">
				<div class="aboutus">
				<p class="pro_inttit">		
					<span>
						关于纯晶
					</span>
				</p>
				<div class="about">
					<p class="gsjj" v-for="item in datalist[0].dlist">
						{{item.content}}<a href="/gycj" class="cgal" target="_blank" style="font-size: 13px;">&nbsp;&nbsp;&nbsp;查看更多>></a>
					</p>
					<p class="aboutimg">
					<!--<img src="../../static/青岛纯晶稀有元素有限公司图片+文字材料/参加的活动/2017年淘宝造物节/IMG_20170712_094155.jpg">
					<img src="../../static/青岛纯晶稀有元素有限公司图片+文字材料/成套的实物元素周期表/北京大学/IMG_20180716_121139.jpg" >
					<img src="../../static/青岛纯晶稀有元素有限公司图片+文字材料/参加的活动/2018年淘宝造物节/IMG_20180913_154249_1.jpg" >
					<img src="../../static/青岛纯晶稀有元素有限公司图片+文字材料/参加的活动/各种科普活动/mmexport1460536893673-1.jpg">-->
					<div style="position:relative;left:40px;" v-for="item in datalist[0].dlist">
				    <viewer :images="datalist[0].dlist">
				        <img :src="item.imageOne" :key="item.imageOne" class="sl_img">
				        <img :src="item.imageTwo" :key="item.imageTwo"  class="sl_img">
				        <img :src="item.imageThree" :key="item.imageThree"  class="sl_img">
				        <img :src="item.imageFour" :key="item.imageFour"  class="sl_img">
				    </viewer>
					</div>
					</p>
				</div>
				</div>
			</div>
			<!--<div class="pro">
			<p class="pro_inttit">
				活动剪影
			</p>
	    <vue-seamless-scroll :data="homeg" :class-option="optionLeft" class="gundongNews">
	        <ul class="item">
	            <li v-for="item in homeg">
	        			<router-link v-bind="{to:'/Prosernr/'+item.articleID}" target="_blank">
	            	<img :src="item.imgUrl" width='135px' height='120px' style="border:1px solid #ccc">
	        			</router-link>
	           </li>
	        </ul>
	    </vue-seamless-scroll>
			</div>-->
			<!--主页主体部分-->
			<div class="homeContent">
					<div class="content_left">
						<ul class="tabs clearfix">
							<li v-for="(tab,index) in tabsName">
								<a :href="tab.path" class="tab-link" @mouseover="tabsSwitch(index)" v-bind:class="{active:tab.isActive,'rightborder':index==0}">{{tab.name}}</a>
							</li>
						</ul>
						<div class="cards">
							<div class="tab-card" style="display: block;">
								<ul>
									<li v-for="item in datalist[1].dlist">
										<router-link v-bind="{to:'/content/'+item.articleID+'?Mbx1=公司新闻'}" :title="item.title" target="_blank">
										{{getShortTitle(item.title,30)}}
										</router-link>
										<span>{{item.updateTime|datefmt('YYYY-MM-DD')}}</span>
									</li>
								</ul>
							</div>
							<div class="tab-card">
								<ul>
									<li v-for="item in datalist[2].dlist">
										<a :href="item.link" :title="item.title" target="_blank">
										{{getShortTitle(item.title,30)}}
										</a>
										<span>{{item.updateTime|datefmt('YYYY-MM-DD')}}</span>
									</li>
								</ul>								
							</div>
							<!--<div class="tab-card">
								<ul>
									<li v-for="item in datalist[3].dlist">
										<router-link v-bind="{to:'/content/'+item.articleID+'?Mbx1=通知公告'}" :title="item.title" target="_blank">
										{{getShortTitle(item.title,30)}}
										</router-link>
										<span>{{item.updateTime|datefmt('YYYY-MM-DD')}}</span>
									</li>
								</ul>								
							</div>-->
						</div>
						<!--成功案例-->
						<div class="f_search">
							<p class="search_obj_title">成功案例<span>Successful</span></p>
						<div class="search_obj">
							<ul>
								<li v-for="item in datalist[6].dlist">
									<router-link v-bind="{to:'/content/'+item.articleID+'?Mbx1=成功案例'}" :title="item.title" target="_blank" class="cgal">
									{{getShortTitle(item.title,10)}}
									</router-link>
								</li>
								<li><a href="/cgal" class="cgal" target="_blank">查看更多>></a></li>
								</ul>
            </div>
						</div>
					</div>
					<div class="content_right">
						<p class="jianjie_title">实物元素周期表<span></span></p>
						<div class="jianjie_box1" v-for="item in datalist[3].dlist">
							<viewer :images="datalist[3].dlist">
	              <img :src="item.imageUrl" width="118px" height="80px">
	            </viewer>
	              <a href="/swyszqb" target="_blank">{{item.categories}}<span>[详情]</span></a>
						</div>
						<p class="jianjie_title jianjie_title2">淘宝店相关<span></span></p>
						<div class="jianjie_box1" v-for="item in datalist[4].dlist">
							<viewer :images="datalist[4].dlist">
	              <img :src="item.imageUrl" width="118px" height="80px">
	              </viewer>
	              <a href="https://shop106506395.taobao.com/?spm=a230r.7195193.1997079397.2.6b9229ea4yr4CJ" target="_blank">{{item.content}}<span>[详情]</span></a>
						</div>
					</div>
			</div>
			<div class="pro">
			<p class="pro_inttit">
				活动剪影
			</p>
			    <vue-seamless-scroll :data="datalist[5].dlist" :class-option="optionLeft" class="gundongNews">
			        <ul class="item">
			            <li v-for="item in datalist[5].dlist">
			            		<a href="/hdjy" target="_blank">
			                	<img :src="item.imageUrl" :key="item.imageUrl" width='140px' height='100px' class="jyImg">
			                	<span class="gundongTitle gdTitle">{{getShortTitle(item.title,9)}}</span>
			                </a>
			            </li>
			        </ul>
			    </vue-seamless-scroll>
			</div>
			<VFooter></VFooter>
  </div>
</template>

<script>
import web from "@/assets/js/web.js";
import VAccount from './subcomponents/account'
import VNav from './subcomponents/nav'
import VBanner from './subcomponents/banner'
import VFooter from './subcomponents/footer'
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
	components:{VAccount,VNav,VBanner,VFooter,vueSeamlessScroll},
  name: 'Home',
  data () {
    return {
			picUrl: web.picPath,
			datalist:[
	      {path:'/about/chunjing', cfg:{params:{bg:0, count:1}}, dlist:[]},
	      {path:'/gsxw', cfg:{params:{bg:0, count:5}}, dlist:[]},
	      {path:'/xgbd', cfg:{params:{bg:0, count:5}}, dlist:[]},
	      {path:'/swyszqb', cfg:{params:{bg:0, count:1}}, dlist:[]},
	      {path:'/home/ml', cfg:{params:{bg:0, count:1}}, dlist:[]},
	      {path:'/hdjy', cfg:{params:{bg:0, count:8}}, dlist:[]},
	      {path:'/cgal', cfg:{params:{bg:0, count:5}}, dlist:[]},
			],
			tabsName: [{
				name: "公司新闻",
				isActive: true,
				path:'/xwzxhome'
			}, {
				name: "相关报道",
				isActive: false,
				path:'/xgbd'
			},
			],
			homeg:[],
    }
  },
	created(){
			this.getData(0);    //
			this.getData(1);
			this.getData(2);
			this.getData(3);
			this.getData(4);
			this.getData(5);
			this.getData(6);
			this.getData(7);
			this.getData(8);
			this.getData(9);
			this.getData(10);
	},
	methods:{
      getData(nIndex) {
        web.api.get(this.datalist[nIndex].path, this.datalist[nIndex].cfg)
          .then(res=>{
            if(res.status) {
              this.datalist[nIndex].dlist= res.data;
            }
            else console.log('出错信息:' + res.message);
          })
          .catch(error=>{console.log(error)});
      },
	  	tabsSwitch:function(tabIndex) {
			var tabCardCollection = document.querySelectorAll(".tab-card"),
							len = tabCardCollection.length; 
			for(var i = 0; i < len; i++) {
				tabCardCollection[i].style.display = "none";
				this.tabsName[i].isActive = false;
			}
			this.tabsName[tabIndex].isActive = true;
			tabCardCollection[tabIndex].style.display = "block";
			},
			getShortTitle(cTitleString, ndataMaxLen) {
			    if(cTitleString.length>ndataMaxLen) {
			      return cTitleString.substr(0,ndataMaxLen)+'...';
			    }
			    else return cTitleString;
			}
	},
  computed: {
   	 optionLeft: function () {
        return {
 		  		direction:2,
          limitMoveNum:2,
          step:0.5
        }
     },   
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	*{
			list-style: none;
			color:#333;
		}
	.content_box_top {
	    width: 1200px;
	    height: 150px;
	    margin: 30px auto 35px;
	}
	.content_box_top li {
	    width: 180px;
	    text-align: center;
	    float: left;
	    margin: 0 60px;
	}
	.aboutus{
		width:1200px;
		margin:0 auto;
		margin-top:10px;
		background-color:#F9F9F9;
		box-shadow: 0 0 6px #CCC;
		border: 1px solid white;
	}
.pro_inttit {
    height: 70px;
    line-height: 70px;
    border-bottom: 1px solid #b0b0b0;
    color: #080b0c;
    font-size: 28px;
    text-align: center;
    position: relative;
    width: 90%;
    margin:0 auto;
}
.pro_inttit::before {
    position: absolute;
    content: "";
    width: 48px;
    height: 4px;
    left: 50%;
    background: #1e73ba;
    bottom: -2px;
}
.pro_inttit::after {
    position: absolute;
    content: "";
    width: 48px;
    height: 4px;
    left: 50%;
    margin-left: -48px;
    background: #000000;
    bottom: -2px;
}
.about{
	width:1200px;
}
.aboutimg{
	position:relative;
	left:30px;
}
.sl_img{
	width:260px;
	height: 180px;
	margin-right:30px;
}
.gsjj{
	text-indent: 2em;
	text-align: justify;
	font-size: 15px;
	line-height:28px;
	color:rgb(68,68,68);
	width:95%;
	margin:0 auto;
	font-size: 15px;
}
.pro{
	width: 1200px;
	height:220px;
	background: #f9f9f9;
	margin: 0 auto;
/*	overflow: hidden;*/
	border: 1px red solid;
	box-shadow: 0 0 6px #CCC;
	border: 1px solid white;
	margin-top:20px;
}
.homeContent{
	width: 1202px;
	height: 350px;
	background: #f9f9f9;
	margin: 0 auto;
/*	overflow: hidden;*/
	border: 1px red solid;
	box-shadow: 0 0 6px #CCC;
	border: 1px solid white;
	margin-top:20px;
}
.content_left{
	width:580px;
	height: 320px;
	float: left;
	margin-left:15px;
	margin-top:10px;
}
.content_right{
	width:580px;
	height:320px;
	float: left;
	margin-left: 15px;
	margin-top:20px;
}
/*Tab页*/
	.tabs{
    	display: block;
    	height: 49px;
    	width:580px;
    	border-bottom: 1.8px solid #ccc;		
	}
	.tabs li {
		float: left;
		margin-right: 8px;
		list-style: none;
	}
	.tabs .tab-link {
		text-align: center;
		line-height: 49px;
		color: #6e707b;
		font-size: 1.5em;
		font-weight: bold;
		text-decoration: none;
	}
	
	.tabs .tab-link.active {
		color:#419ad6;
		transition: .3s;
	}
	
	.cards {
		float: left;
	}
	
	.cards .tab-card {
		display: none;
	}
	
	.clearfix:after {
		content: "";
		display: block;
		height: 0;
		clear: both;
	}
	
	.clearfix {
		zoom: 1;
	}
	.tab-card ul li{
		padding-left: 2px;
		margin-top: 5px;
		line-height: 160%;
		font-size: 14px;
		clear: both;
		overflow: hidden;
		position: relative;
		color:#232323;		
	}
	.tab-card ul{
		width:580px;
		margin-top:7px;
	}
	.tab-card ul li span{
		color:#999;
		position:absolute;
		top:0;
		right: 0;
	}
	.rightborder{
		padding-right:15px;
		border-right: 1px solid #ccc;
		margin-right: 8px;
	}
	/*分类搜索*/
	.f_search{
		width:580px;
		height: 160px;
		clear: both;
		position:relative;
		top:20px;
	}
	.search_obj_title {
	    font-size: 16px;
	    color: #419ad6;
	    margin-top: 10px;
	}
	.search_obj .cgal{
	    width: 161px;
	    height: 44px;
	    display: block;
	    float: left;
	    margin: 5px 8px;
	    text-align: center;
	    line-height: 46px;
	    border: 1px solid #e6e6e6;
	    color: #333;
	    background: url(../../static/主页素材图/but_bg.png) repeat-x;
	}
	.search_obj_title span {
    font-size: 14px;
    color: #999999;
    margin-left: 8px;
}
/*实物元素周期表*/
.jianjie_title {
    font-size: 16px;
    color:#419ad6;
}
.jianjie_title span {
    font-size: 12px;
    color: #999999;
    margin-left: 6px;
}
.jianjie_box1 {
    width: 495px;
    height: 96px;
    margin-top: 16px;
    overflow: hidden;
}
.jianjie_box1 img {
    float: left;
    margin-top: 6px;
}
.jianjie_box1 a {
    float: left;
    display: block;
    width: 364px;
    color: #919191;
    margin-left: 10px;
    font-size: 12px;
    line-height: 24px;
}
.jianjie_title2{
	margin-top:40px;
}
.jianjie_box2{
	width:550px;
}
.jianjie_box2 a {
    float: left;
    display: block;
    width: 550px;
    color: #919191;
    margin-left: 10px;
    font-size: 12px;
    line-height: 24px;
}
/*底部图片轮播*/
.ImgPic{
	width:100%;
	position:relative;
	top:-10px;
}
.gundongNews{
  overflow: hidden;
  height:150px;
}
.item{
	width:1200px;
	height: 180px;
	float:left;
	margin-top: 10px;
}
.item li{
	display: inline-block;
	padding-right: 10px;
}
.gdTitle{
	display: block;
	text-align: center;
}
.gdListBottom{
	width:140px;
	height:30px;
	background-color: #83343A;
	position:relative;
	top:10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue